

import Container from '@mui/material/Container'
import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloudDownload from '@mui/icons-material/CloudDownload';
import Button from "@mui/material/Button";

import PropTypes from "prop-types";
import { ListItemButton, Skeleton } from '@mui/material';

function FileDropZone({ loading, id, files = [], setFiles, onRemove, disabled }) {
  const onDrop = useCallback(acceptedFiles => {
    setFiles(acceptedFiles)
  }, [setFiles])

  const handleDownload = async (url, filename) => {
    try {
      // fetch as blob to enforce download
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      window.open(url, '_blank');
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
  if (loading) {
    return <Skeleton sx={{ margin: "auto" }} width="60%" height={200} />
  }

  return (
    <Container>
      <List>
        {files.map((f) => (
          f.url ? (
              <ListItem key={f.name}>
                <ListItemButton onClick={() => handleDownload(f.url, f.name)}>
                  <ListItemIcon>
                    <CloudDownload />
                  </ListItemIcon>
                  <ListItemText primary={f.name} sx={{ color: "gray" }} />
                </ListItemButton>
                <Button disabled={disabled} onClick={() => onRemove(f.name)}> Delete </Button>
              </ListItem>
            ) : (
              <ListItem key={f.name}>
                <ListItemIcon>
                  <CloudDownload />
                </ListItemIcon>
                <ListItemText primary={f.name} sx={{ color: "gray" }} />
                <Button disabled={disabled} onClick={() => onRemove(f.name)}> Delete </Button>
              </ListItem>
            )
        ))}
      </List>
      <Container {...getRootProps()}
        sx={{ backgroundColor: "#1e4d7d", color: "white", minWidth: "600x", minHeight: "150px", borderRadius: "8px" }}>
        <input id={id} {...getInputProps()} onChange={(e) => setFiles(e.target.files)} />
        {
          isDragActive ?
            <p>Drop the files here ...</p> :
            <p>Drag and drop some files here, or click to select files</p>
        }
      </Container>
    </Container>

  )
}

FileDropZone.propTypes = {
  id: PropTypes.string,
  files: PropTypes.array,
  setFiles: PropTypes.func,
  onRemove: PropTypes.func,
  remove: PropTypes.func,
  submit: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};


export default FileDropZone;
